import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { V1Props } from "./ContentListV1.interface";
import { useCardSize } from "./hooks/useCardSize.hook";
import Card from "./components/Card/Card.component";
import { useAlignment } from "./hooks/useAlignment.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./ContentListV1.module.scss";

export const V1 = (props: V1Props) => {
    const { backgroundColorClass, hasBackgroundColor } = useBackgroundColor(props.backgroundColor);
    const { cardSizeClass } = useCardSize(props.cardSize, S);
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { alignmentClass } = useAlignment(props.alignment, S);

    return (
        <div
            className={cn(
                S.wrapper,
                cardSizeClass,
                paddingClass,
                backgroundColorClass,
                alignmentClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Content */}
                    <div className={S.header}>
                        {/** Tagline */}
                        {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                        {/** Title */}
                        {props.headline ? (
                            <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                {props.headline}
                            </DA_Title>
                        ) : null}

                        {/** Text */}
                        {props.text ? <DA_Text html={props.text} noPadding /> : null}
                    </div>

                    {/** Card List */}
                    <div className={S.listWrapper}>
                        {props.subHeading ? (
                            <div className={S.subTitle}>
                                <DA_Title h3 noMargin fullWidth>
                                    {props.subHeading}
                                </DA_Title>
                            </div>
                        ) : null}

                        <div className={S.list}>
                            {props.items?.map((item, index) => (
                                <Card
                                    key={index}
                                    {...item}
                                    isVerticalImage={!!props.verticalImage}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};
export default V1;
